import React from 'react'
import { AlertProps, Box } from '@mui/material'

import { PaletteLiteral } from './theme-provider/theme.tsx'

export interface InfoBoxProps {
  severity?: AlertProps['severity']
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const BOX_COLORS: Record<AlertProps['severity'], PaletteLiteral> = {
  info: 'chip.info.text',
  success: 'chip.success.text',
  error: 'chip.error.text',
}

export const InfoBox = ({ severity = 'info', children }: React.PropsWithChildren<InfoBoxProps>): React.ReactElement => {
  return (
    <Box
      sx={{
        p: 3,
        mb: 3,
        borderLeft: '4px solid',
        borderRadius: 1,
        borderColor: BOX_COLORS[severity],
        backgroundColor: 'background.paper',
      }}
    >
      {children}
    </Box>
  )
}
